<template>
  <div v-if="blok.columns.length" class="content-grid">
    <div class="content-grid__inner">
      <BaseStoryblokComponent
        v-for="item in blok.columns"
        :id="id"
        :key="item._uid"
        :blok="item"
        class="content-grid__item"
        :title="title"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseStoryblokComponent from '@/components/Base/BaseStoryblokComponent/BaseStoryblokComponent.vue'
import { type SbBlokData } from '@/components/Base/BaseStoryblokComponent/types'

defineProps<{
  blok: {
    columns: SbBlokData[]
  }
  title: string
  id: string
}>()
</script>

<style lang="scss">
.content-grid {
  &__inner {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: $sb-size-unit-3xl;
  }
}
</style>
